<template>
  <div
    class="thumbs-color-up-review d-flex align-items-center justify-content-around"
    v-images-loaded:on.progress="imageProgress"
  >
    <div
      class="d-flex flex-column align-items-center h-100"
      style="width: 65%;"
    >
      <div class="thumb-color-img" style="height: 47.5%;">
        <a
          class="d-flex align-items-center justify-content-center"
          v-if="thumbnails.centerPath"
          :href="thumbnails.centerPath"
          target="_blank"
          title="click to download"
        >
          <img
            v-if="thumbnails.centerPath && centerThumbnail"
            data-location="center"
            class="thumb-img img-fluid"
            :src="centerThumbnail"
            alt="Thumb Center"
          />
        </a>
      </div>

      <div style="height: 5%;"></div>

      <div class="thumb-color-img" style="height: 47.5%;">
        <a
          class="d-flex align-items-center justify-content-center"
          v-if="thumbnails.backPath"
          :href="thumbnails.backPath"
          target="_blank"
          title="click to download"
        >
          <img
            v-if="thumbnails.backPath && backThumbnail"
            data-location="back"
            class="thumb-img img-fluid"
            :src="backThumbnail"
            alt="Thumb Back"
          />
        </a>
      </div>
    </div>

    <div
      class="d-flex flex-column align-items-center h-100"
      style="width: 35%;"
    >
      <div class="thumb-color-img" style="height: 47.5%;">
        <a
          class="d-flex align-items-center justify-content-center"
          v-if="thumbnails.sidePath"
          :href="thumbnails.sidePath"
          target="_blank"
          title="click to download"
        >
          <img
            v-if="thumbnails.sidePath && sideThumbnail"
            data-location="side"
            class="thumb-img img-fluid"
            :src="sideThumbnail"
            alt="Thumb Side"
          />
        </a>
      </div>

      <div style="height: 5%;"></div>

      <div class="thumb-color-img" style="height: 47.5%;">
        <a
          class="d-flex align-items-center justify-content-center"
          v-if="thumbnails.rightPath"
          :href="thumbnails.rightPath"
          target="_blank"
          title="click to download"
        >
          <img
            v-if="thumbnails.rightPath && rightThumbnail"
            data-location="right"
            class="thumb-img img-fluid"
            :src="rightThumbnail"
            alt="Thumb right"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component()
export default class ThumbsColorUpReview extends Vue {
  @Prop({
    type: Object,
    required: true,
    default: () => {}
  })
  thumbnails

  @Prop({
    type: String,
    required: true,
    default: ''
  })
  sufixImages

  thumbsLoaded = {}

  imageProgress(instance, image) {
    if (image.isLoaded === true) {
      const location = this._get(image, 'img.dataset.location')
      this.thumbsLoaded[location] = true
    }

    if (
      this.thumbsLoaded.back === true &&
      this.thumbsLoaded.side === true &&
      this.thumbsLoaded.center === true
    ) {
      this.$emit('onThumbsLoaded')
    }
  }

  get centerThumbnail() {
    return this.thumbnails.centerPath + this.sufixImages // this.getImageBase64Src(this.thumbnails.centerPath)
  }

  get sideThumbnail() {
    return this.thumbnails.sidePath + this.sufixImages // this.getImageBase64Src(this.thumbnails.sidePath)
  }

  get rightThumbnail() {
    return this.thumbnails.rightPath + this.sufixImages // this.getImageBase64Src(this.thumbnails.rightPath)
  }

  get backThumbnail() {
    return this.thumbnails.backPath + this.sufixImages // this.getImageBase64Src(this.thumbnails.backPath)
  }
}
</script>

<style lang="scss" scoped>
.thumbs-color-up-review {
  margin: 0 10px;

  .thumb-color-img {
    height: 100%;
  }

  a {
    display: block;
    height: 100%;
  }

  .thumb-img {
    object-fit: cover;
    max-height: 100%;
    max-width: 100%;
  }
}
</style>
